<template>
  <Component :is="mainComponent"/>
</template>

<script>
import LeadsDefault from '@/views/LeadsDefault.vue'
import LeadsInsights from '@/views/LeadsInsights.vue'

export default {
  name: 'Leads',

  components: {
    LeadsDefault,
    LeadsInsights
  },

  computed: {
    mainComponent () {
      const { profile } = this.$auth.user()

      return profile === 'platform'
        ? 'LeadsInsights'
        : 'LeadsDefault'
    }
  }
}
</script>
